export const unlinkVueVariable = (data) => {
  return JSON.parse(JSON.stringify(data))
}

export const phoneMask = (val) => {
  return val
    .replace(/\D/g, '')
    .replace(/^(\d)/, '($1')
    .replace(/^(\(\d{3})(\d)/, '$1) $2')
    .replace(/(\d{3})(\d{1,4})/, '$1-$2')
    .replace(/(-\d{4})\d+?$/, '$1')
}

export const SORT_ARRAY = (list, by_column) => {
  if (!Array.isArray(list)) return list
  return list.sort((a, b) => (a[by_column] > b[by_column]) ? -1 : 1)
}

export const SORT_ARRAY_DESC = (list, by_column) => {
  if (!Array.isArray(list)) return list
  return list.sort((a, b) => (a[by_column] < b[by_column]) ? -1 : 1)
}

export const SORT_BY_DATE_ARRAY = (list, by_column) => {
  if (!Array.isArray(list)) return list
  return list.sort((a, b) => (new Date(a[by_column]) > new Date(b[by_column])) ? 1 : -1)
}
